import _arity from "./internal/_arity.js";
import _curry2 from "./internal/_curry2.js";
var bind = _curry2(function bind(fn, thisObj) {
    return _arity(fn.length, function () {
        return fn.apply(thisObj, arguments);
    });
});
export default bind;
